export const generateNumber = (payload) => `${payload}${new Date().getTime()}`;
